$ = require 'jquery'
ArchiveView = require 'views/archive/archive-view'
Auth = require 'db/auth'
BoardMenuAboutThisBoardView = require 'views/board-menu/board-menu-about-this-board-view'
BoardLabelsView = require 'views/board-menu/board-labels-view'
BoardMenuActivityView = require 'views/board-menu/board-menu-activity-view'
BoardSidebarDefaultView = require 'views/board-menu/board-sidebar-default-view'
BoardSettingsView = require 'views/board-menu/board-settings-view'
BoardSettingsAndMoreView = require 'views/board-menu/board-menu-settings-and-more-view'
BoardMenuMoreView = require 'views/board-menu/board-menu-more-view'
BoardCollectionsView = require 'views/board-menu/board-collections-view'
Browser = require 'lib/browser'
CardFilterView = require 'views/board-menu/card-filter-view'
ChangeBoardBackgroundView = require 'views/board-menu/change-board-background-view'
ChangeBoardBackgroundSelectView = require 'views/board-menu/change-board-background-select-view'
getExperiment = require 'lib/experiments/simple-test'
Keys = require 'data/keys'
PopOver = require 'views/lib/pop-over'
StickerPickerView = require 'views/board-menu/sticker-picker-view'
Storage = require 'lib/storage'
UserInput = require 'views/internal/user-input'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
{ featureFlagClient } = require 'common/lib/feature-flag-client'
templates = require 'views/internal/templates'
trackUe = require 'debug/trackUe'

module.exports = class BoardSidebarView extends View

  initialize: ({ @boardView }) ->
    UserInput.addHandler @, { scope: 'board_sidebar' }

    @aboutThisBoardEnabled = @boardView.aboutThisBoardEnabled

    @defaultView = @subview(BoardSidebarDefaultView, @model, sidebarView: @)
    @viewStack = [{ name: 'default', view: @defaultView }]

    @handleATBFlag()
    featureFlagClient.on 'change:publicproduct.about_this_board', (newVal) =>
      @handleATBFlag(newVal)

    return

  events:
    'click .js-hide-sidebar': 'hideSidebar'
    'click .js-pop-widget-view': 'popView'
    'shortcut': 'shortcut'

  shortcut: (key) ->
    switch key
      when Keys.F
        @pushView 'filter'
        "F - Search and Filter Cards"

  className: 'board-menu-container'

  render: ->

    @$el.html(
      templates.fill(
        'board_sidebar'
      )
    )

    # Defer until LD flag value is updated
    @defer =>
      @renderView()

    @

  # Because of these classes aren't yet defined, we need to make this a
  # function. When we get proper requiring, this can become a normal object.
  sidebarSubviews: ->
    default: BoardSidebarDefaultView
    filter: CardFilterView
    about: BoardMenuAboutThisBoardView
    archive: ArchiveView
    stickers: StickerPickerView
    labels: BoardLabelsView
    background: ChangeBoardBackgroundView
    backgroundColors: ChangeBoardBackgroundSelectView
    backgroundPhotos: ChangeBoardBackgroundSelectView
    activity: BoardMenuActivityView
    more: BoardMenuMoreView
    settings: BoardSettingsView
    settingsAndMore: BoardSettingsAndMoreView
    collections: BoardCollectionsView

  hackySidebarLifetimeEvents:
    filter:
      didBecomeVisible: (view) ->
        input = view.$('.js-autofocus')[0]
        Util.setCaretAtEnd input
    more:
      didBecomeVisible: (view) ->
        view.selectUrl()
    archive:
      didBecomeVisible: (view) ->
        input = view.$('.js-autofocus')[0]
        Util.setCaretAtEnd input

  viewNamed: (viewName, options) ->
    for { name, view } in @viewStack
      if viewName == name
        return view

    viewClass = _.result(@, 'sidebarSubviews')[viewName]
    if !viewClass?
      throw new Error "Unknown sidebar view #{viewName}"
    model = if viewName == 'filter' then @model.filter else @model
    new viewClass(_.extend({ model, @modelCache, sidebarView: @, viewState: options?.viewState }, options))

  topSidebarView: ->
    _.last(@viewStack).view

  topSidebarViewOptions: ->
    _.last(@viewStack).options

  topSidebarViewName: ->
    _.last(@viewStack).name

  renderView: (options = {}) ->
    { direction, callOnce, easeIn } = options
    $title = @$('.js-board-menu-title')
    $titleIcon = @$('.js-board-menu-title-icon').empty()
    $titleText = @$('.js-board-menu-title-text').empty()
    $contentWrapper = @$('.js-board-menu-content-wrapper').empty().scrollTop(0)

    view = @topSidebarView()

    @$('.board-menu-header').toggleClass('no-transition', !easeIn)
    $contentWrapper.toggleClass('no-padding', view.noPadding == true)

    if view.headerDisplayTypeClass?
      @$('.js-board-menu-title').addClass(view.headerDisplayTypeClass)
    else
      @$('.js-board-menu-title').removeClass('is-board-menu-default-view')

    $content = view.renderIfNecessary().$el

    if direction? then $content.addClass(direction)

    title = view.getViewTitle()
    if title
      $title.addClass('is-in-frame')
      $titleText.append title
    else
      $title.removeClass('is-in-frame')

    $contentWrapper.append($content)

    # this needs to be instantiated after the $contentWrapper has been cleared
    # of `.board-menu-content-frame`s and after inserting the current frame.
    # Otherwise, the transitionend triggers earlier on an old frame and we
    # don't get our didBecomeVisible.
    if callOnce?
      $('.board-menu-content-frame').one 'transitionend webkitTransitionEnd', (e) =>
        callOnce(view)

    @defer =>
      # without the defer, the browser removes the class too quickly and
      # doesn't animate. i think they are batched somehow.
      if direction? then $content.removeClass(direction)

    # the view can drop events, like when loading a bunch of other sidebar
    # views then using the 'f' shortcut, so reattach them here just in case.
    view.delegateEvents()
    @

  pushView: (name, viewOptions = {}, options = {}) ->
    { animate, showSidebar, easeIn } = options
    animate ?= true
    showSidebar ?= true
    easeIn ?= true

    view = @viewNamed name, viewOptions

    didBecomeVisible = @hackySidebarLifetimeEvents?[name]?.didBecomeVisible ? ->

    isCurrentTopView = view == @topSidebarView()
    isSidebarVisible = @model.viewState.get 'showSidebar'

    if !isSidebarVisible
      $('.board-menu').one 'transitionend webkitTransitionEnd', (e) =>
        didBecomeVisible view
    else if !isCurrentTopView
      callOnce = didBecomeVisible
    else
      didBecomeVisible view

    if showSidebar && !isSidebarVisible
      @model.viewState.setShowSidebar true

    if isCurrentTopView
      return

    previousViewName = @topSidebarViewName()
    @viewStack.push { name, view, options: viewOptions }
    direction =
      if animate
        'is-right-of-frame'
    @renderView({ direction, callOnce, easeIn })

    trackUe('board sidebar', 'opens', "#{@topSidebarViewName()} view", "from #{previousViewName} view",
      '', '', { boardId: @model.id, teamId: @model.getOrganization()?.id } )
    PopOver.hide()
    return

  popView: ->
    if @viewStack.length == 1
      # This is fine -- the board view will try to call this if you hit
      # escape. There's no reason to let the board view know anything
      # about our view stack, as it's internal, so we just silently ignore
      # such a request.
      return

    resetView = @topSidebarViewOptions()?.resetTo
    if resetView
      return @resetTo(resetView)

    previousViewName = @topSidebarViewName()
    @topSidebarView().remove()
    @viewStack.pop()
    @renderView({ animate: 'is-left-of-frame', easeIn: true })

    trackUe('board sidebar', 'opens', "#{@topSidebarViewName()} view", "from #{previousViewName} view",
      '', "by clicking on back button", { boardId: @model.id, teamId: @model.getOrganization()?.id } )
    PopOver.hide()
    return

  resetTo: (view, options = {}) ->
    { animate, showSidebar } = options
    animate ?= true

    previousViewName = @topSidebarViewName()
    while @viewStack.length != 1
      @viewStack.pop()

    if view
      @pushView view, {}, options

    @renderView({ animate: if animate then 'is-left-of-frame' })

    trackUe('board sidebar', 'opens', "#{@topSidebarViewName()} view", "from #{previousViewName} view",
      '', 'via reset', { boardId: @model.id, teamId: @model.getOrganization()?.id } )
    PopOver.hide()
    return

  hideSidebar: ->
    @model.viewState.setShowSidebar(false)
    trackUe('board sidebar', 'closes', 'sidebar', "on #{@topSidebarViewName()} view",
      '', '', { boardId: @model.id, teamId: @model.getOrganization()?.id } )
    return

  getBoardView: ->
    @boardView

  handleATBFlag: (newVal) ->
    if newVal?
      @aboutThisBoardEnabled = newVal && !getExperiment('boardInvitees').get('orient')

    if @model.isPublic() && @aboutThisBoardEnabled
      @pushView('about', {}, { easeIn: false, showSidebar: @model.viewState.get('showSidebar') })
    else if !@aboutThisBoardEnabled && @topSidebarViewName() == 'about'
      @resetTo('default', { showSidebar: @model.viewState.get('showSidebar') })



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-sidebar-view.coffee